<div #csi class="container component-selector-input" [ngClass]="{'button-check' : button_selected}">
  <div class="row bg-gradient component-header-size">
    <h1 class="component-header-title">{{ cardTitle.title | uppercase}}</h1>
  </div>
  <div class="row component-body-size">
    <mat-form-field class="component-form-size" id="component-form-size">
      <input type="text" (keydown.enter)="onQuoteChange(model.assetSymbol, cardTitle.id)" spellcheck="false"
        maxlength="20" name="asset" id="asset" [(ngModel)]="model.assetSymbol" placeholder="digite um ativo" matInput
        [matAutocomplete]="issuingAsset" (keyup)="onAutoCompletAsset($event, cardTitle.id)" ondragstart="return false;"
        ondrop="return false;" style="text-transform:uppercase" (blur)="onQuoteChange(model.assetSymbol, cardTitle.id)">
      <div id="company" class="company">{{ company | uppercase}}</div>
    </mat-form-field>
    <div class="invalid" *ngIf="hiddenInvalidActive">Ativo
      <strong>inválido</strong>.</div>
    <mat-autocomplete #issuingAsset id="issuingAsset" (optionSelected)='optionSelected($event)'
      [autoActiveFirstOption]="false">
      <mat-option *ngFor="let item of filteredAssets" [value]="item.symbol"
        (onSelectionChange)="onchangeSymbol(item, cardTitle.id, model.assetSymbol, item.symbol)">
        {{ item.symbol | uppercase }}
      </mat-option>
    </mat-autocomplete>
  </div>
  <button mat-mini-fab class="button-plus" (click)="addComponent()"
    [disabled]="hiddenInvalidActive || loading"></button>
</div>